module.exports = __webpack_public_path__ + "static/46-11e68b3aee3c1182171e9dee90f3fb92.png";